import { type ElementType, forwardRef, type HTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { sprinkles, type Sprinkles } from '@/theme/sprinkles.css';
import { SPRINKLE_KEYS } from '@/theme/sprinkleKeys';

export type BoxProps = Sprinkles &
  Omit<HTMLAttributes<HTMLElement>, keyof Sprinkles> & {
    as?: ElementType;
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
  };

function splitProps(props: Record<string, unknown>) {
  const sp: Record<string, unknown> = {};
  const hp: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(props)) {
    if (SPRINKLE_KEYS.has(k)) sp[k] = v;
    else hp[k] = v;
  }
  return [sp, hp] as const;
}

export const Box = forwardRef<HTMLElement, BoxProps>(
  ({ as: Tag = 'div', className, style, children, ...rest }, ref) => {
    const [sp, hp] = splitProps(rest as Record<string, unknown>);
    return (
      <Tag
        ref={ref}
        style={style}
        className={clsx(sprinkles(sp as Sprinkles), className)}
        {...hp}
      >
        {children}
      </Tag>
    );
  },
);

Box.displayName = 'Box';
